export default {"src":"/_next/static/media/no_chart_area_data.2b9df35a.svg","height":151,"width":221};